// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"7e4d50f8","453":"6fb021b0"}[chunkId] + ".chunk.js";
};